import { render, staticRenderFns } from "./AppPermissionPicker.vue?vue&type=template&id=6e6ff6e8&scoped=true"
import script from "./AppPermissionPicker.vue?vue&type=script&lang=js"
export * from "./AppPermissionPicker.vue?vue&type=script&lang=js"
import style0 from "./AppPermissionPicker.vue?vue&type=style&index=0&id=6e6ff6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ff6e8",
  null
  
)

export default component.exports